import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

let _selectors = {
    hScrollTarget: '.js-horz-scroll-target',
    hScrollEl: '.h-scroller_cards',
    snapParent: '.js-snap-parent',
    snapSection: '.js-snap-section',
};

// Cached Elements.
let _el = {};

// Module Variables
let _vars = {};
let _snapPanels = []; // Store snap panels for external access

// Module init
const _init = () => {
    // Define & Cache Elements
    _setElements();
    
    _bindEvents();
};

const _bindEvents = () => {

    if(_el.hScrollTarget || _el.snapSection) {
        gsap.registerPlugin(ScrollTrigger);
    }

    if(_el.hScrollTarget) {
        _initHorzScroller();
    }

    if(_el.snapSection.length) {

        // Add padding if other elements come after snap sections
        if (_el.snapParent.length > 0 && _el.snapParent[0].nextElementSibling) {
            _addSnapSectionPadding();
        }
        _initSnapSection();
    }
};

const _initHorzScroller = () => {

    // set all scroll els into gsap sections array
    var sections = gsap.utils.toArray(_el.hScrollTarget);

    // for each scroll el run anim
    sections.forEach((section, i) => {
        let sectionWidth = section.offsetWidth;

        // Skip if the section has the stack-on-mobile class and we're on a mobile viewport
        if (section.classList.contains('h-scroller--stack-on-mobile') && window.innerWidth < 768) {
            return;
        }

        gsap.to($(section).find(_el.hScrollEl), {
            xPercent: -100,
            x: () => innerWidth, // innerWidth is global viewport width
            ease: "power2.inOut",
            duration: sectionWidth / 750,
            scrollTrigger: {
                trigger: section,
                start: "center center", // Height of logo
                end: `bottom-=${window.innerHeight / 2} top`,
                scrub: true,
                pin: true,
                toggleClass: { targets: section, className: "is-pinned" },
            },
        });

        // This fixes the "jump" when the scroller is pinned
        // TODO: Find the right callback/time to trigger this
        setTimeout(() => {
            ScrollTrigger.refresh();
        }, 1000);

    });
}

const _addSnapSectionPadding = () => {

    // Function to set padding and margin for snap sections
    const setPadding = () => {
        let lastPanel = _el.snapSection[_el.snapSection.length - 1];
        let lastPanelHeight = lastPanel.offsetHeight;
        gsap.set(_el.snapParent[0], { paddingBottom: lastPanelHeight + 'px' });
        gsap.set(lastPanel, { marginBottom: '0px' });
    };
    
    // Run initially
    setPadding();
    
    // Run on window resize
    window.addEventListener('resize', setPadding);
}


// Office locations snap section
// Recalc section height when accordions open/close
const _initSnapSection = () => {

    _snapPanels = gsap.utils.toArray(_el.snapSection).map(panel => ScrollTrigger.create({
        trigger: panel,
        start: () => panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom", // if it's shorter than the viewport, we prefer to pin it at the top
        pin: true, 
        pinSpacing: false,
        duration: 1.5,
        ease: "power4.out",
        onRefresh: ({progress, direction, isActive}) => console.log(progress, direction, isActive)
    }));
}

// Set/Reset and Cache Module elements
const _setElements = () => {
    // Cache Elements into _el & create variable to check existence
    Object.keys(_selectors).forEach(key => {
        const el = document.querySelectorAll(_selectors[key]);
        _el[key] = el;
        _vars[key] = el.length;
    });
};

const hScroller = {
    init: _init,
    getSnapPanels: () => _snapPanels,
    refreshSnapPanels: () => {
        _snapPanels.forEach(panel => panel.refresh());
    }
};

export default hScroller;